import { ThemeProvider, Toaster } from '@giftsay/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider as ReduxProvider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { useAuthListener } from './features/auth/hooks/use-auth-listener.js';
import { queryClient } from './lib/query-client.js';
import { router } from './routes/router.js';
import { store } from './store/store.js';

/**
 * Must mount unconditionally, before routing decides anything — `ProtectedRoute`
 * blocks on `status === 'loading'` until this listener resolves it, so it can't
 * live behind `ProtectedRoute` itself (that was a deadlock: nothing could ever
 * flip `status` away from `loading`, so every route just hung on "Loading...").
 */
function AuthenticatedRoot() {
  useAuthListener();
  return <RouterProvider router={router} />;
}

export function App() {
  return (
    <ReduxProvider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AuthenticatedRoot />
          {/* Mounted here, not inside AdminShell, so toasts also show on /login (sign-in errors). */}
          <Toaster richColors position="top-center" />
        </ThemeProvider>
      </QueryClientProvider>
    </ReduxProvider>
  );
}
